import { throttle, debounce } from "../utilities/toolkit";
/**
 * sticky add to cart panel handler
 * shows and hides the sticky panel based on main add-to-cart button visibility
 */
class StickyAddToCartPanel {
	constructor() {
		const _ = this;
		// store dom elements
		_.addToCartButton = document.querySelector(
			'[data-element="main-product-form"] [data-element="add-to-cart-button"]',
		);
		_.stickyPanel = document.querySelector(
			'[data-component="sticky-add-to-cart-panel"]',
		);

		_.bindUI();

		// only initialize if both elements exist
		if (_.addToCartButton && _.stickyPanel) {
			_.initialize();
		}
	}

	bindUI() {
		const _ = this;

		document.addEventListener("click", (event) => {
			if (!event.target.closest('[data-action="trigger-add-to-cart-form"]')) {
				return;
			}
			// trigger click on form
			_.addToCartButton.click();
		});
	}

	/**
	 * initialize the sticky panel functionality
	 */
	initialize() {
		const _ = this;
		// initially hide the panel
		_.hidePanel();
		// create handler function for both scroll and resize events
		const handleScroll = throttle(
			debounce(_.checkButtonVisibility.bind(_), 100),
			100,
		);
		// bind scroll event
		window.addEventListener("scroll", handleScroll);
		// also check on window resize as dimensions may change
		window.addEventListener("resize", handleScroll);
		// check initially in case page loads already scrolled
		_.checkButtonVisibility();
	}
	/**
	 * check if add to cart button is visible in viewport
	 */
	checkButtonVisibility() {
		const _ = this;

		// Absolute position from top of viewport
		const scrollY = window.scrollY;
		const buttonTop = _.addToCartButton.getBoundingClientRect().top;
		const buttonScollPos = buttonTop + scrollY - 50;

		if (buttonTop > 50 && buttonTop < window.innerHeight - 10) {
			_.hidePanel();
		} else if (scrollY > buttonScollPos) {
			// only show if we've scrolled past the form button
			_.showPanel();
		}
	}
	/**
	 * show the sticky panel
	 */
	showPanel() {
		const _ = this;
		_.stickyPanel.setAttribute("aria-hidden", "false");
	}
	/**
	 * hide the sticky panel
	 */
	hidePanel() {
		const _ = this;
		_.stickyPanel.setAttribute("aria-hidden", "true");
	}
}
// initialize on dom content loaded
document.addEventListener("DOMContentLoaded", () => {
	new StickyAddToCartPanel();
});
